export default __webpack_public_path__ + "static/media/component003Student-right.6c72bbf1.svg";